export default "__VITE_ASSET__X5XEJG7R__"